import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StepperNavButtonsComponent } from './stepper-nav-buttons.component';
import { MaterialModule } from '../../modules/material.module';

@NgModule({
  declarations: [StepperNavButtonsComponent],
  exports: [StepperNavButtonsComponent],
  imports: [CommonModule, MaterialModule],
})
export class StepperNavButtonsModule {}
